import type { RefObject } from 'react';
import { fadeTo } from 'util/animation/fade/fade';

interface OfficeDetailsRefs {
  elementRef: RefObject<HTMLElement | null>;
}

export function setupTransitionInTimeline(
  timeline: gsap.core.Timeline,
  { elementRef }: OfficeDetailsRefs,
): void {
  timeline.fromTo(elementRef.current, {}, {});
}

export function setupTransitionOutTimeline(
  timeline: gsap.core.Timeline,
  { elementRef }: OfficeDetailsRefs,
): void {
  timeline.add(fadeTo(elementRef.current as HTMLElement));
}
